<template>
  <div>
    <Card
      icon="clock"
      title="History"
    >
      <loading-spinner />
      <History
        v-if="!loadingStatus"
        :items="history"
        :show-actions="true"
      />
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card'
import History from '@/components/History/index'
import { mapState } from 'vuex'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    Card,
    History,
    LoadingSpinner
  },
  computed: {
    ...mapState({
      history: state => {
        let firstOcurrence = true
        return state.templateBuilder.template.history.sort((a, b) => new Date(b.date) - new Date(a.date)).map(item => {
          if (firstOcurrence) {
            item.currentVersion = true
            firstOcurrence = false
          } else {
            item.currentVersion = false
          }
          return item
        })
      },
      accountId: state => state.templateBuilder.accountId
    }),
    loadingStatus () {
      return this.$store.getters.getLoadingStatusItem('set_template_history')
    }
  },
  watch: {
    accountId () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.accountId) {
        const templateId = this.$route.query.templateId
        const userEmail = atob(this.$route.query.userEmail)
        if (templateId) {
          if (this.history.length === 0) this.$store.dispatch('setTemplateHistory', { templateId, userEmail })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
